import { tokenize } from '@engpod/core';
import { useMemo } from 'react';

/** English sentence with tappable words. Returns the token index of the tapped word. */
export function Sentence({ text, onWord, highlight }: { text: string; onWord?(tokenIndex: number): void; highlight?: [number, number] | null }) {
  const tokens = useMemo(() => tokenize(text), [text]);
  return (
    <span className="sentence-text">
      {tokens.map((t, i) =>
        t.word && onWord ? (
          <span
            key={i}
            className={`word${highlight && i >= highlight[0] && i <= highlight[1] ? ' picked' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              onWord(i);
            }}
          >
            {t.text}
          </span>
        ) : (
          <span key={i}>{t.text}</span>
        ),
      )}
    </span>
  );
}
